{
  "enterCodeBelow": "Enter your verification code below",
  "resendEmail": "Resend Verification Email",
  "tokenSentTo": "New verification token sent to {{email}}.",
  "tokenAlreadySentTo": "Verification token already sent to {{email}}.",
  "unableToResend": "Unable to resend verification email at the moment, try again in a few minutes.",
  "verified": "Verified!",
  "failed": "Verification failed",
  "errors": {
    "generic": "Encountered an error during verification",
    "missingParams": "Missing verification parameters",
    "invalidCode": "Invalid verification code",
    "tooManyAttempts": "Too many attempts, please try again in a few hours",
    "mustBeLoggedIn": "You must be logged in to verify your email address"
  }
}
